import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import ViewContentBlock from "@/App/Layouts/ViewContentBlock";
import AuthorizedTenantElement from "@/common/components/Auth/AuthorizedTenantElement";
import EntityCommentsChat from "@/common/components/Entity/Chat/View/EntityCommentsChat";
import { EntityType, VehicleDto } from "@/core/api/generated/v1";

interface Props {
  vehicle: VehicleDto;
}

export default function CommentsTabContent({ vehicle }: Props) {
  return (
    <PageTabContent>
      <AuthorizedTenantElement tenantIdsAny={[vehicle?.tenantId, vehicle?.ownerTenantId]} withAlert>
        <ViewContentBlock spacing={2}>
          <EntityCommentsChat
            entityId={vehicle.id!}
            entityType={EntityType.Vehicle}
            entity={vehicle}
          />
        </ViewContentBlock>
      </AuthorizedTenantElement>
    </PageTabContent>
  );
}
